module.exports = __webpack_public_path__ + "static/bgless3.69a20648.png";